import { Component } from "@angular/core";

@Component({
	selector: "caass-OneCardExpress",
	templateUrl: "./OneCardExpress.component.html",
})
export class OneCardExpressComponent {}
